import React, { useEffect } from "react";
import Modal from "react-modal";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./generic-modal.css";

interface GenericModalProps {
    children: JSX.Element;
    isOpen: boolean;
    onAfterOpen?: () => void;
    onClose: () => void;
}

function GenericModal({
    children,
    isOpen,
    onAfterOpen,
    onClose,
}: GenericModalProps): null | JSX.Element {
    let appElement: HTMLElement | undefined;
    if (document.body) {
        appElement = document.body.querySelector<HTMLDivElement>(".site-wrapper") || undefined;
    }

    useEffect(() => {
        document.body.classList.toggle("no-scroll", isOpen);
        return (): void => {
            document.body.classList.remove("no-scroll");
        };
    }, [isOpen]);

    return (
        <Modal
            appElement={appElement}
            className={styles.modal}
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onClose}
            overlayClassName={styles.overlay}
        >
            <div className={styles.closeContainer}>
                <CloseButton className={styles.closeButton} onClick={onClose} />
            </div>
            <div>{children}</div>
        </Modal>
    );
}

export default GenericModal;
